import {stripeCreateCard, StripeCreateCard} from "./create-card/StripeCreateCardComponent";
import {stripeCreateCardFooter, StripeCreateCardFooter} from "./create-card/footer/StripeCreateCardFooterComponent";
import {stripeManage, StripeManage} from "./manage/StripeManageCardComponent";
import {currentStripeCard, CurrentStripeCard} from "./current-card-summary/CurrentStripeCardComponent";

export default function(parentDir: string) {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.stripe.components", [])
                  .component(StripeCreateCard, stripeCreateCard(rootDir))
                  .component(StripeCreateCardFooter, stripeCreateCardFooter())
                  .component(CurrentStripeCard, currentStripeCard(rootDir))
                  .component(StripeManage, stripeManage(rootDir))
                  .name;
}
